export default "__VITE_ASSET__7b0936ca__"